import { gql } from '@apollo/client/core';

export const getZipcodes = gql`
  query GetZipcodes(
    $first: Int!
    $where: ZipcodeFilterInput
    $after: String
    $order: [ZipcodeSortInput!]
  ) {
    zipcodes(first: $first, where: $where, after: $after, order: $order) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        city
        code
        state
        #active
        #createdAt
        #createdBy
        #id
        #timezoneId
        #updatedAt
        #updatedBy
      }
    }
  }
`;
